import ReactDOM from "react-dom";

import App from "./components/App";

ReactDOM.render(<App />, document.querySelector(".root"));

/* DEPLOY VERCEL IN - israelfelipet@gmail.com */
